import general from "./general";

export const outputs = {
    general,
}

export default outputs;